import React from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import PageViewer from "./ui/Helpers/PageViewer";
import PageViewerV2 from "./ui/Helpers/PageViewerV2";
import createToastContainer from "./globalHelpers/ErrorMessageUI";
import Radium from "radium";
import styleWrap from "./globalHelpers/GlobalStyleWrapper";
import CustomerHelper from "./globalHelpers/CustomerHelper";
import Flush from "./ui/Widgets/Flush";
import "./styles/global.css";
import StateTree from "./globalHelpers/StateTree";
import Modal from "./ui/Components/Modal";
import ContentViewer from "./ui/Helpers/ContentViewer";
import BillView from "./ui/Widgets/BillView";
import LoginHelper from "./globalHelpers/LoginHelper";
import MaintenancePage from "./ui/Widgets/MaintenancePage";
import moment from "moment";
import Cookies from "universal-cookie";
import CrossSiteLogin from "./ui/Components/CrossSiteLogin";
import { generateGlobalCache } from "./ui/Helpers/GlobalCacheHelper";
import { setLanguage } from "./globalHelpers/LanguageHelper";
import SurveyHelper from "./ui/Helpers/SurveyHelper";

// Components CSS Import
import "./styles/components/InputV2.css";
import "./styles/components/DropdownV2.css";

generateGlobalCache();
const cookies = new Cookies();

window.Buffer = window.Buffer || require("buffer").Buffer;

console.warn = console.error = () => {};

const isLinked = async () => {
    const user = await CustomerHelper.fetchUser();
    if (user && user.customers && user.customers.length > 0) {
        return true;
    } else {
        return false;
    }
};

const requireAccountSession = async () => {
    if (!window.sessionStorage.getItem("sessionId")) {
        window.location.href = "/";
    } else {
        const linked = await isLinked();

        if (!linked) {
            window.location.href = "/link";
        } else {
            const timeout = window.siteSettings.sessionTimeout || 30;

            setTimeout(() => {
                LoginHelper.logout();
                window.location.href = "/";
            }, timeout * 60 * 1000);

            setTimeout(() => {
                Express.callAsync("validate-session", {
                    sessionId: Express.getSessionId(),
                });

                CustomerHelper.fetchSession();
            }, 1000);

            if (window.sessionStorage.getItem("uau_update")) return;

            StateTree.subscribe("accountContext", async (results) => {
                try {
                    if (!results || !results.accountId) return;

                    if (window.sessionStorage.getItem("uau_update")) return;

                    window.sessionStorage.setItem("uau_update", true);

                    const userId = await CustomerHelper.fetchUserId();

                    Express.call("update-user-account-list", {
                        userId,
                        sessionId: Express.getSessionId(),
                    });
                } catch (e) {
                    console.log(e);
                }
            });
        }
    }
};

const requireAgentSession = async () => {
    if (
        !window.sessionStorage.getItem("sessionId") &&
        window.location.pathname != "/agent"
    ) {
        window.location.href = "/agent";
    } else {
        const user = await CustomerHelper.fetchAgentUser();
        Express.call("check-agent-access", { user }, (results) => {
            if (results && results.hasAccess) {
                setTimeout(() => {
                    Express.callAsync("validate-agent-session", {
                        sessionId: Express.getSessionId(),
                    });
                    CustomerHelper.fetchSession();
                }, 1000);
            } else {
                if (window.location.pathname != "/agent") {
                    LoginHelper.agentLogout();
                    window.location.href = "/";
                }
            }
        });
    }
};

const requireSession = () => {
    if (!window.sessionStorage.getItem("sessionId")) {
        window.location.href = "/";
    }
};

const hasSession = async () => {
    if (window.sessionStorage.getItem("sessionId")) {
        const linked = await isLinked();
        if (!linked) {
            window.location.href = "/link";
        } else {
            window.location.href = "/dashboard";
        }
    }
};

const initializeStyleConstants = () => {
    try {
        Express.callPublic("get-site-name", null, (siteName) => {
            Express.callPublic(
                "fetch-site-settings",
                { siteName },
                (siteConfig) => {
                    const styleConstants = siteConfig["style-constants"];
                    localStorage.setItem(
                        "style-constants",
                        JSON.stringify(styleConstants)
                    );
                }
            );
        });
    } catch (e) {
        console.log(e);
    }
};

function injectStyleConstants(styleConstants) {
    try {
        if (!styleConstants) return;

        const rootElement = document.querySelector(":root");

        if (!rootElement) return;

        rootElement.style.setProperty(
            "--primary-bg-color",
            styleConstants.__primary
        );
        rootElement.style.setProperty(
            "--primary-bg-color-dark",
            styleConstants.__primarydark
        );
        rootElement.style.setProperty(
            "--secondary-bg-color",
            styleConstants.__secondary
        );
        rootElement.style.setProperty(
            "--secondary-bg-color-dark",
            styleConstants.__secondarydark
        );
        rootElement.style.setProperty(
            "--primary-text-color",
            styleConstants.__primaryText || "white"
        );
        rootElement.style.setProperty(
            "--secondary-text-color",
            styleConstants.__secondaryText || "white"
        );
    } catch (e) {
        console.log(e);
    }
}

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            siteConfig: null,
            loading: true,
            ErrorMessageUI: null,
            openModel: false,
            inMaintenance: false,
            loadingMaintenance: true,
            maintenanceError: false,
        };
    }

    async componentDidMount() {
        initializeStyleConstants();
        this.setState({ loadingMaintenance: true });
        await this.checkMaintenance();
        this.fetchSiteConfig();
    }

    async checkMaintenance() {
        try {
            const maintenance = await Express.callPublic(
                "fetch-in-maintenance-mode",
                {}
            );

            if (!maintenance || !("inMaintenance" in maintenance)) {
                this.setState({
                    maintenanceError: true,
                    loading: false,
                    loadingMaintenance: false,
                });
                return;
            }

            this.setState({
                inMaintenance: maintenance.inMaintenance,
                loadingMaintenance: false,
                maintenanceError: false,
            });
        } catch (e) {
            console.log(e);
            this.setState({
                maintenanceError: true,
                loading: false,
                loadingMaintenance: false,
            });
        }
    }

    async fetchSiteConfig() {
        Express.callPublic("get-site-name", null, (siteName) => {
            Express.callPublic(
                "fetch-site-settings",
                { siteName },
                (siteConfig) => {
                    let styleConstants =
                        localStorage.getItem("style-constants");

                    styleConstants = siteConfig["style-constants"];
                    localStorage.setItem(
                        "style-constants",
                        JSON.stringify(styleConstants)
                    );

                    global["style-constants"] = styleConstants || {
                        __primary: "#7bc245",
                        __secondary: "#ffffff",
                        __primaryDark: "#55872f",
                        __secondaryDark: "#e1e1e1",
                    };

                    injectStyleConstants(styleConstants);

                    const language = cookies.get("language");

                    if (language && language.length > 0) {
                        setLanguage(language);
                    }

                    styleWrap(siteConfig.style, async (styleMap) => {
                        siteConfig.style = styleMap;
                        const ErrorMessageUI = await createToastContainer();
                        try {
                            window.siteSettings = siteConfig.siteConfig.site;
                            window.agentPortal =
                                siteConfig.siteConfig.agentPortal;
                        } catch (e) {}

                        const labels = await Express.callAsyncPublic(
                            "get-store",
                            {
                                key: "labels",
                            }
                        );
                        window.labels = labels;
                        StateTree.update("labels", labels);

                        if (
                            window.siteSettings &&
                            window.siteSettings.hubspot
                        ) {
                            this.injectHubSpot(window.siteSettings.hubspot);
                        }

                        if (
                            window.siteSettings &&
                            window.siteSettings.qualtrics
                        ) {
                            this.injectQualtrics(window.siteSettings.qualtrics);
                        }

                        if (
                            siteConfig.siteConfig.site &&
                            siteConfig.siteConfig.site.scripts
                        ) {
                            this.injectScripts(
                                siteConfig.siteConfig.site.scripts
                            );
                        }

                        if (window.siteSettings.maintenancePolling) {
                            setInterval(() => {
                                this.checkMaintenance();
                            }, window.siteSettings.maintenancePolling);
                        }

                        if (
                            siteConfig.siteConfig.site &&
                            siteConfig.siteConfig.site.pageViewer === "V2"
                        ) {
                            this.setState({ isNewPageViewer: true });
                        }

                        this.setState({
                            siteConfig,
                            loading: false,
                            ErrorMessageUI,
                        });

                        this.validationPaths();
                    });
                }
            );
        });
    }

    injectHubSpot(hubspot) {
        try {
            const script = document.createElement("script");
            script.src = hubspot;
            script.id = "hs-script-loader";
            document.body.appendChild(script);
        } catch (error) {
            console.log(error);
        }
    }

    async injectQualtrics(qualtrics) {
        try {
            const results = await SurveyHelper.setupCookies(cookies);

            if (results && results.error) {
                return;
            }

            const hasShown = cookies.get("shownQualtrics");
            const URL = window.location.href.split("/");
            const endOfURL = URL[URL.length - 1];
            const hasDashboard = window.location.href.includes("dashboard");
            if (
                qualtrics &&
                endOfURL !== "dashboard" &&
                !hasShown &&
                hasDashboard
            ) {
                const script = document.createElement("script");
                script.src = qualtrics;
                script.type = "text/javascript";
                document.body.append(script);

                cookies.set("shownQualtrics", true, {
                    expires: moment().add(1, "month").toDate(),
                });

                window.location.href += "#survey=true";
            }
        } catch (error) {
            console.log(error);
        }
    }

    injectScripts(scripts) {
        try {
            if (!scripts || !(scripts.length > 0)) return;

            for (let i = 0; i < scripts.length; i++) {
                const script = scripts[i];
                const scriptTag = document.createElement("script");

                const keys = Object.keys(script);

                for (let a = 0; a < keys.length; a++) {
                    const key = keys[a];
                    scriptTag[key] = script[key];
                }

                document.body.appendChild(scriptTag);
            }
        } catch (e) {
            console.log(e);
        }
    }

    validationPaths() {
        if (window.location.pathname.includes("agent")) {
            return requireAgentSession();
        }
        if (window.location.pathname.includes("dashboard")) {
            return requireAccountSession();
        }
        if (window.location.pathname.includes("link")) {
            return requireSession();
        }
        if (window.location.pathname == "/") {
            return hasSession();
        }
    }

    renderModal() {
        return (
            <Modal height="500" width="200" open={this.state.openModal}>
                <React.Fragment>
                    <ContentViewer overrideContent="UnenrollBudget" />
                </React.Fragment>
            </Modal>
        );
    }

    render() {
        if (this.state.loading) {
            return <div />;
        }

        if (this.state.loadingMaintenance) {
            return <div />;
        }

        if (this.state.maintenanceError) {
            return (
                <div style={{ textAlign: "center", padding: "5em" }}>
                    Apologies, an unexpected error occurred communicating with
                    our systems. Please reload the page to try again.
                </div>
            );
        }

        if (this.state.inMaintenance) {
            return <MaintenancePage />;
        }

        try {
            return (
                <div style={this.state.siteConfig.style}>
                    <Router>
                        <Switch>
                            <Route path="/loginService/*">
                                <CrossSiteLogin />
                            </Route>
                            <Route path="/bill-view">
                                <BillView />
                            </Route>
                            <Route path="/flush-all">
                                <Flush />
                            </Route>
                            <Route path="/">
                                {this.state.isNewPageViewer ? (
                                    <PageViewerV2 />
                                ) : (
                                    <PageViewer />
                                )}
                            </Route>
                        </Switch>
                    </Router>
                    {this.state.ErrorMessageUI && <this.state.ErrorMessageUI />}
                    {this.renderModal()}
                </div>
            );
        } catch (e) {
            console.log(e);
            return <div />;
        }
    }
}

export default Radium(App);
